import { render } from "./AddDing.vue?vue&type=template&id=f8cd986c"
import script from "./AddDing.vue?vue&type=script&lang=js"
export * from "./AddDing.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\phili\\work\\dingsda\\dingsda_2mex_frontend\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__